import React from 'react';
import { EnhancedPlanetaryDignity } from '../utils/planetaryDignityEngine';
import { Language } from '../types/kundali';
import { DignityHoverCard, ShadbalaHoverCard, NatureHoverCard, NakshatraHoverCard } from './PlanetaryHoverPopover';

export const DetailedPlanetaryPopoverContent: React.FC<{
  dignity: EnhancedPlanetaryDignity;
  lang: Language;
}> = ({ dignity, lang }) => {
  return (
    <div className="space-y-4 max-w-sm">
      <DignityHoverCard item={dignity} lang={lang} />
      <div className="border-t border-astro-border/60 pt-3">
        <ShadbalaHoverCard item={dignity} lang={lang} />
      </div>
      <div className="border-t border-astro-border/60 pt-3">
        <NatureHoverCard item={dignity} lang={lang} />
      </div>
      <div className="border-t border-astro-border/60 pt-3">
        <NakshatraHoverCard item={dignity} lang={lang} />
      </div>
    </div>
  );
};
